module.exports = __webpack_public_path__ + "img/life_style_level_2_30000.b66a1a92.jpg";